export default "__VITE_PUBLIC_ASSET__dca1ec52__"